import axios from 'axios'
import { ATUALIZAR_REGITRO_MANUTENCAO_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function atualizarManutencaoVeiculo(registro) {
  const url = `${URL}/registro-manutencao-veiculo/atualizar`;

  return dispatch => axios.post(url, registro, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: ATUALIZAR_REGITRO_MANUTENCAO_VEICULO,
      payload: response
    })
  );
}